import React from "react";
import styled, { css } from "styled-components";
import { Field } from "formik";
import i18n from "i18n";
import { Input } from "components/bootstrap";
const Operator = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.spacings.sm};
  `
);
const OperatorField = () => /* @__PURE__ */ React.createElement(Field, { name: "operator" }, ({ field }) => /* @__PURE__ */ React.createElement(Operator, null, /* @__PURE__ */ React.createElement(
  Input,
  {
    type: "radio",
    name: field.name,
    checked: field.value === "AND",
    onChange: field.onChange,
    value: "AND",
    label: i18n.t("operator_field.and", { ns: "enterprise_data_lake" }),
    formGroupClassName: ""
  }
), /* @__PURE__ */ React.createElement(
  Input,
  {
    type: "radio",
    name: field.name,
    checked: field.value === "OR",
    onChange: field.onChange,
    value: "OR",
    label: i18n.t("operator_field.or", { ns: "enterprise_data_lake" }),
    formGroupClassName: ""
  }
)));
export default OperatorField;
